import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // only scroll to the top if there's no scrollTo state
    if (!state?.scrollTo) {
      window.scrollTo({ top: 0 });
    }
  }, [pathname, state]);

  return null;
}